import axios from 'axios';

import type { IAuthServiceListener } from '@sine/auth-client';
import { TeamSwitcherInterceptor, TeamSwitcherService } from '@sine/sine-team-switcher';

import authService from '../auth/auth.service';
import { storage } from '../storage/storage.service';
import teamScopingService from './teamScoping.service';

const teamSwitcherService = new TeamSwitcherService(teamScopingService.teamsCallback, storage);

const teamSwitcherInterceptor = new TeamSwitcherInterceptor(axios, teamSwitcherService);
teamSwitcherInterceptor.startIntercepting();

/**
 * Wait until the auth service has got a logged in user and then initialise the team service.
 * If the logged in user changes (for some reason) then initialise again!
 */
let initialisedUserId: string | undefined;

const handleAuthStateChange: IAuthServiceListener['func'] = ({ authState, userDetails }) => {
  if (authState === 'loggedIn' && (!initialisedUserId || initialisedUserId !== userDetails?.id)) {
    initialisedUserId = userDetails?.id;
    void teamSwitcherService.reinitialise();
  }
};

handleAuthStateChange(authService.getAuthState());
authService.addAuthStateListener(handleAuthStateChange);

export default teamSwitcherService;
